<template>
  <div class="modal">
    <div class="background-overlay"></div>
    <div class="message-container">
      <div @click="$emit('close')" class="modal-close">
        <CloseIcon />
      </div>
      <div class="modal-content">
        <h2 class="choose-number-header">Choose your phone number</h2>
        <div class="choose-number-content">
          <div class="floating-label has-icon">
            <input
              v-model="code"
              @input="validateInput"
              placeholder="Search by area code..."
              type="text"
              name="code"
              id="code"
              autocomplete="off"
            />
            <label for="code">
              Search by area code
            </label>
            <div class="input-icon">
              <svg
                v-if="!isSearching"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.07 16.8292L19 14.7092C18.5547 14.286 17.9931 14.0055 17.3872 13.904C16.7813 13.8024 16.1589 13.8843 15.6 14.1392L14.7 13.2392C15.7605 11.8221 16.2449 10.0559 16.0555 8.29604C15.8662 6.5362 15.0172 4.91343 13.6794 3.75441C12.3417 2.59538 10.6145 1.98617 8.84565 2.04939C7.07678 2.11262 5.39754 2.8436 4.14596 4.09518C2.89438 5.34676 2.1634 7.026 2.10017 8.79487C2.03695 10.5637 2.64617 12.2909 3.80519 13.6286C4.96421 14.9664 6.58699 15.8154 8.34683 16.0048C10.1067 16.1941 11.8729 15.7098 13.29 14.6492L14.18 15.5392C13.8951 16.0988 13.793 16.7338 13.8881 17.3545C13.9831 17.9753 14.2706 18.5505 14.71 18.9992L16.83 21.1192C17.3925 21.681 18.155 21.9966 18.95 21.9966C19.745 21.9966 20.5075 21.681 21.07 21.1192C21.3557 20.8398 21.5828 20.5061 21.7378 20.1378C21.8928 19.7694 21.9726 19.3738 21.9726 18.9742C21.9726 18.5746 21.8928 18.179 21.7378 17.8106C21.5828 17.4423 21.3557 17.1086 21.07 16.8292ZM12.59 12.5892C11.8902 13.2872 10.9993 13.7622 10.0297 13.9541C9.06017 14.146 8.05549 14.0462 7.14259 13.6674C6.2297 13.2886 5.44955 12.6477 4.9007 11.8257C4.35185 11.0038 4.05893 10.0376 4.05893 9.04921C4.05893 8.06084 4.35185 7.09464 4.9007 6.27267C5.44955 5.4507 6.2297 4.80983 7.14259 4.43102C8.05549 4.05221 9.06017 3.95246 10.0297 4.14436C10.9993 4.33626 11.8902 4.81121 12.59 5.50921C13.0556 5.97367 13.4251 6.52542 13.6771 7.13287C13.9292 7.74032 14.0589 8.39154 14.0589 9.04921C14.0589 9.70688 13.9292 10.3581 13.6771 10.9655C13.4251 11.573 13.0556 12.1248 12.59 12.5892ZM19.66 19.6592C19.567 19.7529 19.4564 19.8273 19.3346 19.8781C19.2127 19.9289 19.082 19.955 18.95 19.955C18.818 19.955 18.6873 19.9289 18.5654 19.8781C18.4436 19.8273 18.333 19.7529 18.24 19.6592L16.12 17.5392C16.0263 17.4462 15.9519 17.3356 15.9011 17.2138C15.8503 17.0919 15.8242 16.9612 15.8242 16.8292C15.8242 16.6972 15.8503 16.5665 15.9011 16.4446C15.9519 16.3228 16.0263 16.2122 16.12 16.1192C16.213 16.0255 16.3236 15.9511 16.4454 15.9003C16.5673 15.8495 16.698 15.8234 16.83 15.8234C16.962 15.8234 17.0927 15.8495 17.2146 15.9003C17.3364 15.9511 17.447 16.0255 17.54 16.1192L19.66 18.2392C19.7537 18.3322 19.8281 18.4428 19.8789 18.5646C19.9296 18.6865 19.9558 18.8172 19.9558 18.9492C19.9558 19.0812 19.9296 19.2119 19.8789 19.3338C19.8281 19.4556 19.7537 19.5662 19.66 19.6592Z"
                  fill="#DEDEDE"
                />
              </svg>

              <svg
                v-else
                class="w-6 h-6 text-white animate-spin"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  class="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  stroke-width="4"
                ></circle>
                <path
                  class="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
            </div>
          </div>
          <transition name="fade">
            <ul v-if="code.length > 0" class="numbers-list-container">
              <li
                v-if="isSearching"
                class="flex items-center justify-center w-full p-3"
              >
                <svg
                  class="w-6 h-6 text-white animate-spin"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    class="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    stroke-width="4"
                  ></circle>
                  <path
                    class="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
              </li>
              <span
                class="text-lilac"
                v-if="
                  !isSearching &&
                    availableNumbers.length == 0 &&
                    initialSearchDone
                "
                >No numbers found, try a different area code.</span
              >
              <li
                class="w-full"
                v-for="(number, index) in availableNumbers"
                :key="index"
              >
                <input
                  type="radio"
                  :id="number"
                  name="number"
                  :value="number"
                  class="hidden peer"
                  v-model="selectedNumber"
                />
                <label
                  :for="number"
                  class="inline-flex items-center justify-between w-full h-12 px-3 py-4 transition bg-transparent border border-transparent border-dashed rounded-lg cursor-pointer hover:border-light-purple ordinal lining-nums slashed-zero tabular-nums text-lilac "
                  :class="{
                    'bg-light-purple': selectedNumber === number,
                  }"
                >
                  <div class="block">
                    <p class="w-full text-sm">{{ formatNumber(number) }}</p>
                  </div>
                  <svg
                    v-if="selectedNumber === number"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      width="24"
                      height="24"
                      rx="12"
                      fill="url(#paint0_linear_23_10145)"
                    />
                    <path
                      d="M18.7104 7.20986C18.6175 7.11613 18.5069 7.04174 18.385 6.99097C18.2632 6.9402 18.1324 6.91406 18.0004 6.91406C17.8684 6.91406 17.7377 6.9402 17.6159 6.99097C17.494 7.04174 17.3834 7.11613 17.2904 7.20986L9.84044 14.6699L6.71044 11.5299C6.61392 11.4366 6.49998 11.3633 6.37512 11.3141C6.25026 11.2649 6.11694 11.2408 5.98276 11.2431C5.84858 11.2454 5.71617 11.2741 5.59309 11.3276C5.47001 11.3811 5.35868 11.4583 5.26544 11.5549C5.1722 11.6514 5.09889 11.7653 5.04968 11.8902C5.00048 12.015 4.97635 12.1484 4.97867 12.2825C4.98099 12.4167 5.00972 12.5491 5.06321 12.6722C5.1167 12.7953 5.19392 12.9066 5.29044 12.9999L9.13044 16.8399C9.2234 16.9336 9.334 17.008 9.45586 17.0588C9.57772 17.1095 9.70843 17.1357 9.84044 17.1357C9.97245 17.1357 10.1032 17.1095 10.225 17.0588C10.3469 17.008 10.4575 16.9336 10.5504 16.8399L18.7104 8.67986C18.8119 8.58622 18.893 8.47257 18.9484 8.34607C19.0038 8.21957 19.0324 8.08296 19.0324 7.94486C19.0324 7.80676 19.0038 7.67015 18.9484 7.54365C18.893 7.41715 18.8119 7.3035 18.7104 7.20986Z"
                      fill="white"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_23_10145"
                        x1="1.45"
                        y1="22.7382"
                        x2="23.1697"
                        y2="1.90267"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#9C27B0" />
                        <stop offset="1" stop-color="#9733EE" />
                      </linearGradient>
                    </defs>
                  </svg>
                </label>
              </li>
            </ul>
          </transition>
        </div>
      </div>
      <div class="modal-footer">
        <div class="button-container">
          <button
            @click="$emit('close')"
            class="button-default button-default--outline big"
          >
            <span>Cancel</span>
          </button>
        </div>
        <div class="button-container">
          <button
            @click="claimNumber"
            class="button-default big"
            :disabled="isLoading"
          >
            <span v-if="!isLoading">Claim Number</span>
            <svg
              v-else
              class="w-6 h-6 text-white animate-spin"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                class="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                stroke-width="4"
              ></circle>
              <path
                class="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";

import CloseIcon from "../../../public/img/icons/close.svg";
import { PhoneNumberFormat, PhoneNumberUtil } from "google-libphonenumber";
import debounce from "lodash/debounce";

export default {
  components: {
    CloseIcon,
  },
  props: {
    artist_id: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      availableNumbers: [],
      code: "",
      radioStateSingle: "default",
      selectedNumber: "",
      isSearching: false,
      isLoading: false,
      initialSearchDone: false,
    };
  },
  methods: {
    async searchNumbers(prefix) {
      this.isSearching = true;
      prefix = Number(prefix);
      const response = await this.$apollo.query({
        query: gql`
          query SearchNumbers($prefix: Int!) {
            search_numbers(prefix: $prefix) {
              data
            }
          }
        `,
        variables: {
          prefix,
        },
      });

      // setTimeout(() => {
      //   const response = {
      //     data: {
      //       search_numbers: {
      //         data:
      //           prefix < 100
      //             ? '["12137864755","12137864756","12137864758","12137864759","12137864760","12137864763","12137864767","12137864770","12137864771","12137864773","12137864775","12137864782","12137864785","12137864787","12137864788","12137864789","12137864790","12137864793","12137864794","12137864795","12137864796","12137864797","12137864838","12137864850","12137864851","12137864852","12137864853","12137864854","12137864855","12137864856","12137864860","12137864861","12137864862","12137864863","12137864864","12137864868","12137864869","12137864870","12137864871","12137864872","12137864874","12137864875","12137864879","12137864881","12137864882","12137864884","12137864885","12137864886","12137864889","12137864890"]'
      //             : "[]",
      //       },
      //     },
      //   };

      this.availableNumbers = JSON.parse(response.data.search_numbers.data);

      this.isSearching = false;

      this.initialSearchDone = true;
      // }, 300);
    },
    formatNumber(number) {
      const phoneUtil = PhoneNumberUtil.getInstance();
      let phoneNumber;
      try {
        phoneNumber = phoneUtil.parseAndKeepRawInput(number, "US");
      } catch (err) {
        console.error(err);
        return number;
      }
      return phoneUtil.format(phoneNumber, PhoneNumberFormat.NATIONAL);
    },
    validateInput() {
      this.code = this.code.replace(/[^0-9]/g, "");
      if (this.code.length > 0) this.searchDebounced();
    },
    searchDebounced: debounce(function() {
      this.searchNumbers(this.code);
    }, 300),

    async claimNumber() {
      if (this.isTrial) {
        this.$store.dispatch("snack", {
          text:
            "You're still in trial, you need to have an active billing method to do this.",
          autoDismiss: false,
        });

        this.$router.push("/billing");
        return;
      }

      if (!this.selectedNumber)
        return this.$store.dispatch("snack", {
          type: "error",
          text: "Please select a number to claim.",
        });
      try {
        this.isLoading = true;
        const mutation = gql`
          mutation ClaimNumber($number: String!, $artist_id: String!) {
            claim_number(number: $number, artist_id: $artist_id) {
              success
              data
            }
          }
        `;

        const response = await this.$apollo.mutate({
          mutation,
          variables: {
            number: this.selectedNumber,
            artist_id: this.artist_id,
          },
        });

        if (response.data.claim_number.success) {
          await this.$store.dispatch("snack", {
            text: "Number claimed successfully!",
          });

          this.$emit("numberChosen");

          this.$emit("close");
        } else {
          await this.$store.dispatch("snack", {
            type: "error",
            text: response.data.claim_number.data,
          });
        }
        this.isLoading = false;
      } catch (err) {
        console.error(err);
        this.isLoading = false;
      }
    },
  },
  async mounted() {},

  computed: {
    user() {
      return this.$store.getters.getUser;
    },
    isTrial() {
      return (
        (this.user.braintree_subscription_status == "Trial" ||
          !this.user.braintree_subscription_status) &&
        this.user.plan != "family"
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
  overflow: auto;

  .message-container {
    padding: 60px 0 0;
    width: 680px;
    z-index: 98;
    background: linear-gradient(
      241.25deg,
      rgba(41, 39, 85, 0.45) 4.4%,
      rgba(41, 39, 84, 0.85) 61.77%,
      rgba(27, 24, 66, 0.45) 119.94%
    );
    backdrop-filter: blur(23px);
    border-radius: 10px;

    .modal-close {
      cursor: pointer;
      position: absolute;
      top: 18px;
      right: 18px;
      display: flex;
      flex-direction: column;

      &:hover {
        svg {
          path {
            fill: white;
          }
        }

        .close-text {
          color: white;
        }
      }

      svg {
        width: 24px;

        path {
          fill: #8786ab;
        }
      }
    }

    .modal-content {
      display: flex;
      flex-direction: column;
      align-items: start;
      padding: 0 40px 40px;
      gap: 24px;

      .choose-number-header {
        color: #fff;
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
      }

      .choose-number-content {
        display: flex;
        flex-direction: column;
        align-items: start;
        gap: 16px;
        width: 100%;

        .numbers-list-container {
          width: 100%;
          max-height: 400px;
          min-height: 50px;
          border-radius: 10px;
          padding: 16px;
          background: var(--Purple-dark, #100e2a);
          overflow-y: auto;
          display: flex;
          flex-direction: column;
          justify-items: start;
          align-items: start;
          gap: 4px;

          /* Custom Scrollbar */
          &::-webkit-scrollbar {
            width: 8px;
          }

          &::-webkit-scrollbar-track {
            background: #100e2a;
          }

          &::-webkit-scrollbar-thumb {
            background: #9c27b0;
            border: 2px solid transparent;

            border-radius: 10px;
          }

          &::-webkit-scrollbar-thumb:hover {
            background: #9c27b0;
          }
        }
      }
    }

    .modal-footer {
      padding: 0 40px 40px;
      display: flex;
      justify-content: end;
      align-items: center;
      gap: 12px;

      button {
        padding: 9px 40px;
      }
    }
  }

  .background-overlay {
    z-index: 97;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    cursor: unset;
    /* Purple-dark */
    background: $purple-dark;
    opacity: 0.9;
    webkit-backdrop-filter: blur(10px) !important;
    backdrop-filter: blur(10px) !important;
  }
}

input {
  outline: none !important;
  border: none !important;
  box-shadow: none !important;
}

input:focus {
  outline: none !important;
  border: none !important;
  box-shadow: none !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
